import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LangContext";
import { t } from "../i18n/translations";
import { formatApiError } from "../lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { lang } = useLang();
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-sand-soft px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-border rounded-md p-10">
        <img
          src="https://customer-assets.emergentagent.com/job_massage-portal-6/artifacts/g3nld1od_logo_transparent_background.webp"
          alt="Ayurveda Aargau"
          className="h-20 w-auto object-contain mb-6"
        />
        <h1 className="font-display text-3xl text-ink">{t(lang, "admin.login")}</h1>
        <p className="text-sm text-ink-muted mt-2">Ayurveda Aargau · Admin</p>
        <div className="mt-8 space-y-4">
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-ink-muted">{t(lang, "admin.email")}</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email-input"
              className="mt-2 w-full px-4 py-2.5 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-terracotta/40" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-ink-muted">{t(lang, "admin.password")}</span>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input"
              className="mt-2 w-full px-4 py-2.5 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-terracotta/40" />
          </label>
        </div>
        {err && <div className="mt-4 text-sm text-destructive" data-testid="admin-login-error">{err}</div>}
        <button type="submit" disabled={loading} className="mt-8 w-full py-3 bg-terracotta text-white rounded-md hover:bg-terracotta-hover disabled:opacity-50" data-testid="admin-login-submit">
          {loading ? "…" : t(lang, "admin.sign_in")}
        </button>
      </form>
    </div>
  );
}
